<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        Submitted_List
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Submitted WebShell</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail_search -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">Registed_at</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1M</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_is_done">Status</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" v-model="so.opt['is_done']" @change="refresh">
              <option disabled value="">Please select Status</option>
              <option value='true'>Complete</option>
              <option value='false'>Wait</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_is_binary">Binary</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" v-model="so.opt['is_binary']" @change="refresh">
              <option disabled value="">Please select option</option>
              <option value='true'>Binary</option>
              <option value='false'>Not Binary</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_result">Result</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" :dsiabled="so.adv && (so.opt['is_done'] == 'true')" v-model="so.opt['result']" @change="refresh">
              <option disabled value="">Please select result</option>
              <option value='1'>Enable</option>
              <option value='0'>Disable</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_hash">Hash</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_hash" v-model="so.opt['hash']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_filename">Filename</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_filename" v-model="so.opt['filename']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- base64 라서 검색 안됨 -->
      <!-- <b-row>
        <b-col md="12">
          <b-form-group>
            <label for="opt_">content</label>
            <br>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_content" v-model="so.opt['content']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row> -->
      <!-- <b-row>
        <b-col md="12">
          <b-form-group>
            <label for="opt_description">Description</label>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_description" v-model="so.opt['description']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row> -->
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">Match Type</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">Match all</b-form-radio>
              <b-form-radio value="or">Match at least one</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail_search -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false" sm="2">
        <span class="badge badge_border_primary mb-2">Total : <span style="padding-left: 2.3rem"></span>{{model.total.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_info mb-2">Approved : <span style="padding-left: 0.5rem"></span>{{model.approved.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_warning mb-2">Waiting : <span style="padding-left: 1.4rem"></span>{{model.waiting.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_danger mb-2">Deleted : <span style="padding-left: 1.3rem"></span>{{model.rejected.toString().padStart(6, nbsp) | number}}</span>
      </b-col>
      
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || 'Search'" v-model="so.sk" @change="sv_reset">
              <option value="">Search</option>
              <option value="group.groupname">Group</option>
              <option value="filename">FileName</option>
              <option value="hash">MD5</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh" v-show="so.skt!='Complete' && so.skt!='Result'"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mb7 mr-2 mt-2">
            <div class="custom-control custom-checkbox">
              <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
            </div>
          </div>
          <div class="mb7 mr-2 mt-2">
            <button type="button" class="btn btn-sm btn-addition" tabindex="4" @click="$router.push({ name: 'wsfinder_regist' })">
              New Registration
            </button>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="10">Show count : Default 10</option>
              <option value=15>15</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="not found"
            :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" @row-clicked="detail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="group" slot-scope="row">
              <del v-if="row.item.is_del">
                {{row.item.group ? (row.item.group && row.item.group.groupname) : '-'}}
              </del>
              <span v-else>{{row.item.group ? (row.item.group && row.item.group.groupname) : '-'}}</span>
            </template>
            <template slot="filename" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.filename}}</del>
              <span v-else>{{row.item.filename ? row.item.filename : '-'}}</span>
            </template>
            <template slot="md5" slot-scope="row">{{row.item.md5}}</template>
              <template slot="is_done" slot-scope="row">
              <b-badge :variant="row.item.is_done ? 'success' : 'secondary'">
                {{row.item.is_done ? 'Done' : 'Waiting'}}
              </b-badge>
            </template>
            <template slot="is_alive" slot-scope="row">
              <b-badge :variant="row.item.is_done ? (row.item.is_alive ? (row.item.is_del ? 'danger' : 'success') : 'danger') : (row.item.is_del ? 'danger' : '-')">
                {{row.item.is_done ? ( row.item.is_alive ? (row.item.is_del ? 'Deleted' : 'Approved') : 'Rejected') : (row.item.is_del ? 'Deleted' : '-')}}
              </b-badge>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
    <!-- <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>